import { useCallback, useState } from "react";
import ImportDialog from "./ImportDialog";
import { Button, LinkButton } from "components/core/basic/Button";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "utils/api";
import getURLPrefix from "utils/getUrlPrefix";
import axios from "axios";
import { useAppSelector } from "redux/hooks";
import FileSaver from "file-saver";
import { FaSpinner } from "react-icons/fa";
import { css } from "../../../../styled-system/css";
import { VStack } from "../../../../styled-system/jsx";

const API_URL = getURLPrefix();

const ImportButton = (props) => {
  const [importType, setImportType] = useState(null);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const channelType = "channel";
  const marketPlace = useAppSelector((state) => state.marketPlace);
  const queryClient = useQueryClient();
  const orgId = useAppSelector((state) => state.user.organization_id);

  const reset = useCallback(() => {
    setImportType(null);
    setSelectedOrg(null);
    props.setImportModalOpen && props.setImportModalOpen(false);
    props.setImportType && props.setImportType(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (props.defaultType && importType !== props.defaultType) {
    setImportType(props.defaultType);
  }

  const makeTemplate = useMutation({
    mutationFn: async () => {
      const {
        data: { export_id: exportId },
      } = await api.post(`/api/custom_reports/`, {
        mp: marketPlace.marketPlace,
        report_type: "product_category_report",
        is_task: false,
        params: {},
      });
      for (let i = 0; i < 100; i++) {
        const { data: exportObj } = await api.get(`/exports/${exportId}/`);
        if (exportObj.status === 2) {
          const url = `${API_URL}/api/exports/${exportObj.id}/download/`;
          const response = await axios({
            method: "GET",
            url: url,
            responseType: "blob",
          });

          const blob = new Blob([response.data], {
            type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          });

          FileSaver.saveAs(blob, `${exportObj.name}.xlsx`);
          return;
        }
        if ([3, 4].includes(exportObj.status)) {
          // Failed or Cancelled
          return;
        }
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
    },

    onSuccess: async () => {
      return queryClient.invalidateQueries({
        queryKey: ["exports"],
      });
    },
  });

  return (
    <VStack alignItems={"stretch"} gap="xsmall">
      <Button
        onPress={() => {
          const org = {
            id: orgId,
          };
          setImportType(null);
          setSelectedOrg(org);
          setImportType(channelType);
          props.setImportModalOpen && props.setImportModalOpen(true);
        }}
        style={props.style ? props.style : {}}
      >
        {props.title ? props.title : "Import Products"}
      </Button>
      {props.showDownloadTemplate && (
        <LinkButton
          className={css({ fontSize: "medium" })}
          isDisabled={makeTemplate.isPending}
          onPress={() => {
            makeTemplate.mutate();
          }}
        >
          {makeTemplate.isPending ?
            <>
              <FaSpinner className="fa-spin" />{" "}
            </>
          : null}
          Download Template
        </LinkButton>
      )}

      {importType === "channel" && !selectedOrg ?
        <ImportDialog
          isOpen={props.importModalOpen ?? true}
          onClose={reset}
          importType={importType}
          selectedOrg={selectedOrg}
        />
      : importType === "master" || selectedOrg ?
        <ImportDialog
          isOpen={props.importModalOpen ?? true}
          onClose={reset}
          importType={importType}
          selectedOrg={selectedOrg}
        />
      : importType === "pricing_bulk_upload" || selectedOrg ?
        <ImportDialog
          isOpen={props.importModalOpen ?? true}
          onClose={reset}
          importType={importType}
          selectedOrg={selectedOrg}
        />
      : importType === "pricing_relationships" || selectedOrg ?
        <ImportDialog
          isOpen={props.importModalOpen ?? true}
          onClose={reset}
          importType={importType}
          selectedOrg={selectedOrg}
        />
      : importType === "product_po_history" || selectedOrg ?
        <ImportDialog
          isOpen={props.importModalOpen ?? true}
          onClose={reset}
          importType={importType}
          selectedOrg={selectedOrg}
        />
      : null}
    </VStack>
  );
};
export default ImportButton;
